import {
  ComponentRef,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import {EditComponentStepComponent} from "../../_components/edit-component-step/edit-component-step.component";

@Directive({
  selector: '[editComponentStep]',
  standalone: true
})
export class StepDirective implements OnInit, OnChanges {
  @Output() onStepChange = new EventEmitter();
  @Input() index: number = 0;
  @Input() current: number = 0;
  @Output() currentChange = new EventEmitter<number>();

  @Input() model: number = 0;
  @Input() label: string | undefined;
  private component: ComponentRef<EditComponentStepComponent> | undefined;

  constructor(private viewContainer: ViewContainerRef,
              private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'md:flex-1');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.component) return;
    this.assign(this.component.instance)
  }

  ngOnInit(): void {
    this.component = this.viewContainer.createComponent(EditComponentStepComponent);

    // Move the component's native element INSIDE the <li>
    const hostElement = this.component.location.nativeElement;
    this.renderer.appendChild(this.el.nativeElement, hostElement);

    this.assign(this.component.instance);
  }


  private assign(component: EditComponentStepComponent) {
    component.index = this.index;
    component.current = this.current;
    component.model = this.model;
    component.label = this.label;
    component.onStepChange.subscribe(() => {
      this.currentChange.emit(this.model);
    });
  }

}
